export default {
  DAILY: 0,
  DAILY_CLUSTER: 1,
};



// WEBPACK FOOTER //
// ./src/modules/Statistics/_data/dailyView.js